(function($) {
	const matrixTbl = $('#matrix .matrix__table'),
		  classMuted = 'is-muted',
		  classHover = 'is-hover';
	
	// Mute the table cells on hover
	matrixTbl
	.mouseenter(function () {
		$(this).find('tr td').addClass(classMuted);
	})
	.mouseleave(function () {
		$(this).find('tr td').removeClass(classMuted);
	});
  
	// Bind the actions to the tbody td
	matrixTbl.delegate('td', 'mouseover mouseleave', function (e) {
		if (e.type == 'mouseover') {
			var id = $(this).index();

			$(this).parent().addClass(classHover);
			$('colgroup').eq(id).addClass(classHover);

			$('tr').each(function () {
				$(this).find('td').eq(id).removeClass(classMuted);
			});
		} else {
			$(this).parent().removeClass(classHover);
			$('colgroup').removeClass(classHover);
		
			$('tr').each(function () {
				$(this).find('td').addClass(classMuted);
			});
		}
	});
  
	// Use list.js to sort the material name
	if($('#matrix .matrix__table').length > 0) {
		var options = {
			valueNames: [ 'name' ]
		};
	  
		var matrixList = new List('matrix', options);
	}    

	// Tooltip show/hide function
	$(document).on('mouseenter','.matrix__tooltip-btn', function (e) {
	// $('.matrix__tooltip-btn').hover(function(e) {
		e.preventDefault();
		$(this).next('.tooltip').stop().fadeIn(250);
	});
	$(document).on('mouseleave','.matrix__tooltip-btn', function () {
		$(this).next('.tooltip').stop().fadeOut(250);
	});

	// Filter panel button toggle function
	$('.filter-panel-button').click(function(e) {
		e.preventDefault();
		
		const $this = $(this),
		      filterPanel = $(this).next('.filter-panel'),
			  matrixKey = $(this).siblings('.matrix__key');

		if($(this).hasClass('is-active')) {
			filterPanel.slideUp(350);
			
			setTimeout(function(){
				$this.removeClass('is-active');
				matrixKey.fadeIn(350);
			}, 400);
		}
		else {
			matrixKey.fadeOut(350);

			setTimeout(function(){
				$this.addClass('is-active');
				filterPanel.slideDown(350);
			}, 400);
		}
	});

	// bind the event to the category type button 
	$('.btn-category-type').bind('click', function(e) {
		e.preventDefault();

		const id = $(this).attr('id');

		if (id == '*') {
			$('.matrix__table td:not(:first-child)').each(function () {
				$(this).fadeIn(250);
			});
		} else {
			$('.matrix__table td:not(:first-child)').each(function () {
				if ($(this).data('type') == id) {
					$(this).fadeIn(250);
				} else {
					$(this).fadeOut(250);
				}
			});
		}
	});

	// bind the event to the level type button 
	$('.btn-level-type').bind('click', function(e) {
		e.preventDefault();

		const id = $(this).attr('id'),
			  $this = $(this);

		if($('.btn-level-type.is-active').length > 0) {
			if($this.hasClass('is-active')) {
				$this.removeClass('is-active');

				$('.matrix__table td').each(function () {
					if ($(this).hasClass(id)) {
						$(this).addClass('is-hidden');
					}
				});
			}
			else {
				$this.addClass('is-active');

				$('.matrix__table td').each(function () {
					if ($(this).hasClass(id)) {
						$(this).removeClass('is-hidden');
					}
				});
			}
		}
		else {
			$this.addClass('is-active');

			$('.matrix__table td').each(function () {
				if ($(this).hasClass(id)) {
					$(this).removeClass('is-hidden');
				} else {
					$(this).addClass('is-hidden');
				}
			});
		}
	});

	// bind the event to the level reset button
	$('.btn-level-type-reset').bind('click', function(e) {
		e.preventDefault();

		$('.key__list button').each(function () {
			$(this).removeClass('is-active');
		});

		$('.matrix__table td').each(function () {
			$(this).removeClass('is-hidden');
		});
	});

	// bind the event to the uses type button 
	$('.btn-uses-type').bind('click', function(e) {
		e.preventDefault();

		const usesID = $(this).attr('id');

		if (usesID == '*') {
			$('.matrix__table tbody tr').each(function() {
				$(this).removeAttr('style');
			});
		}
		else {
			$('.matrix__table tbody tr').each(function() {
				$(this).toggle($('td:eq(1):contains(' + usesID + ')', this).length > 0);
			});
		}
	});

	// bind the event to the show all uses type button
	$('.btn-show-all-uses').bind('click', function(e) {
		e.preventDefault();

		$('.filter-panel__filter--uses ul li').each(function(){
			$(this).show();
		});

		$('.filter-panel__filter--uses ul li:last-child').hide();
	});

	// bind the event to the industry type button 
	$('.btn-industry-type').bind('click', function(e) {
		e.preventDefault();

		const industryID = $(this).attr('id');

		if (industryID == '*') {
			$('.matrix__table tbody tr').each(function() {
				$(this).removeAttr('style');
			});
		}
		else {
			$('.matrix__table tbody tr').each(function() {
				$(this).toggle($('td:eq(1):contains(' + industryID + ')', this).length > 0);
			});
		}
	});

	// bind the event to the show all industry types button
	$('.btn-show-all-industry').bind('click', function(e) {
		e.preventDefault();

		$('.filter-panel__filter--industry ul li').each(function(){
			$(this).show();
		});

		$('.filter-panel__filter--industry ul li:last-child').hide();
	});

})( jQuery );